import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_CERTIFICATE_DOCUMENT,
  SOFTLINE_API_CERTIFICATE_DOCUMENT_QUERY,
  SOFTLINE_API_CERTIFICATE_SUPPLIER,
} from './certificate.api';
import {
  Certificate,
  CertificateDocumentType,
  DocumentCertificate,
  DocumentCertificateRequest,
} from './certificate.types';

@Injectable({ providedIn: 'root' })
export class CertificateRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  loadSupplierCertificates(supplierId: number): Promise<Certificate[]> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CERTIFICATE_SUPPLIER,
      pathParams: { supplierId },
    });
  }

  // 204 (no certificate on the document) resolves with null
  loadDocumentCertificate(
    documentType: CertificateDocumentType,
    documentId: number
  ): Promise<DocumentCertificate | null> {
    return this.#dataAccess.get({
      path: SOFTLINE_API_CERTIFICATE_DOCUMENT_QUERY,
      pathParams: { documentType, documentId },
    });
  }

  async saveDocumentCertificate(request: DocumentCertificateRequest): Promise<void> {
    await this.#dataAccess.update(
      { path: SOFTLINE_API_CERTIFICATE_DOCUMENT },
      request
    );
  }
}
